// opervex-frontend/src/Opervex/Sales/SalesOrder.js

class SalesOrder {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  async findId(id) {
    return this.#_api.get("/Sales/SalesOrder/" + id);
  }

  async update(id, data) {
    return this.#_api.put("/Sales/SalesOrder/" + id, data);
  }

  async create(data) {
    return this.#_api.post("/Sales/SalesOrder/", data);
  }

  async findAll() {
    return this.#_api.get("/Sales/SalesOrder");
  }

  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "description",
        label: "Descrição",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "documentDate",
        label: "Data do Documento",
        type: "date",
        visible: true,
        hidden: false,
      },
      {
        key: "customerName",
        label: "Nome do Cliente",
        type: "string",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default SalesOrder;
